export enum InspectionState {
    UPCOMING = 'UPCOMING',
    REQUESTED = 'REQUESTED',
    SKIPPED = 'SKIPPED',
    CANCELLED = 'CANCELLED',
    CONFIRMED = 'CONFIRMED',
}
